export default {
  CHANGE_PROFILE_START: "CHANGE_PROFILE_START",
  CHANGE_PROFILE_SUCCESS: "CHANGE_PROFILE_SUCCESS",
  CHANGE_PROFILE_ERROR: "CHANGE_PROFILE_ERROR",
  // GET_PROFILE_START: "GET_PROFILE_START",
  // GET_PROFILE_SUCCESS: "GET_PROFILE_SUCCESS",
};
